import { Router } from '@lightningjs/sdk'
import SpeechComp from '../../components/speechComp/speechComp'
import { HOME } from '../../constants/routes'
import { ModalParams } from '../../widgets/modal'

export default class PageHandler extends SpeechComp {
  protected _isRoot = false

  get page() {
    return Router.getActiveHash()
  }

  _setup() {
    this.resetPageName()
  }

  _handleBack(event) {
    event.preventDefault()

    this.handleBackKey()
  }

  setLoadingAnimation(on: boolean) {
    this.widgets.loading.visible = on
  }

  setModal(on: boolean, data?: ModalParams) {
    this.widgets.modal.visible = on
    if (data) {
      this.widgets.modal.data = data
    }

    if (on) {
      ;(Router.getActivePage() as any)._setState('InBackgroundByModal')
      Router.focusWidget('Modal')
    }
  }

  setSideModal(on: boolean, data?: SideModalParams) {
    this.widgets.sidemodal.visible = on
    if (data) {
      this.widgets.sidemodal.data = data
    }
  }

  setToastNotification(on: boolean, data?) {
    this.widgets.toastnotification.visible = on
    if (data) {
      this.widgets.toastnotification.data = data
    }
  }

  focusActiveModal() {
    Object.values(this.widgets).some((widget: any) => {
      if (widget.ref !== 'Menu' && widget.visible) {
        Router.focusWidget(widget.ref)
      }
    })
  }

  handleBackKey() {
    const history = Router.getHistory()

    if (history.length === 0 && !this._isRoot) {
      Router.navigate(HOME)
      return
    }

    if (this._isRoot) {
      Router.focusWidget('Menu')

      return
    }

    Router.back()
  }

  $handleBackAction() {
    this.handleBackKey()
  }
}
